import React, { useState, useEffect, useContext } from 'react'
import AdminContext from '../../StateContext/Application';
import { apiurl } from '../../../../path';
import { Link, useNavigate } from 'react-router-dom';
// import { Back32, Cancel32, ProposalCreation32, submit } from '../../../../../public/LoginImages/importimages';

const EditWorkOrderList = () => {
    const context = useContext(AdminContext)
    const { GetWorkOrderInwardsList, ProposalApprovalOperation } = context;
    const nav = useNavigate();

    const [technicalInwards, setTechnicalInwards] = useState([])
    const [loading, setLoading] = useState(false);
    const [rejectPanelhide, setRejectpanelhide] = useState(1);
    const [remark, setRemark] = useState("");
    const [selectedBills, setSelectedBills] = useState([]);
    const [filteredBills, setFilteredBills] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const billsPerPage = 10;
    const [searchTerm, setSearchTerm] = useState('');

    const totalPages = Math.ceil(filteredBills?.length / billsPerPage);
    const indexOfLastBill = currentPage * billsPerPage;
    const indexOfFirstBill = indexOfLastBill - billsPerPage;
    const currentBills = filteredBills?.slice(indexOfFirstBill, indexOfLastBill);

    const getTechnicalInwardsList = async () => {
        let data = await GetWorkOrderInwardsList('ALLSendBackWorkOderlist', 'All')
        console.log("data------------", data);

        setTechnicalInwards(data)
        setFilteredBills(data);
    }

    useEffect(() => {
        getTechnicalInwardsList()
    }, []);

    let inwardList = []
    if (technicalInwards.length > 0) {
        inwardList = technicalInwards
    }

    useEffect(() => {
        const lowerSearchTerm = searchTerm.toLowerCase();
        const filtered = technicalInwards.filter(bill =>
            Object.values(bill).some((val) =>
                (val || '').toString().toLowerCase().includes(lowerSearchTerm)
            )
        );
        setFilteredBills(filtered);
        setCurrentPage(1);
    }, [searchTerm, technicalInwards]);



    // const handleCheckboxChange = (id) => {
    //     setSelectedBills((prevSelected) =>
    //         prevSelected.includes(id)
    //             ? prevSelected.filter((billId) => billId !== id)
    //             : [...prevSelected, id]
    //     );
    // };

    // console.log("Slected id form table :: ", selectedBills);
    // console.log("Filtered data id form table :: ", filteredBills);

    // const handleSelectAll = (event) => {
    //     if (event.target.checked) {
    //         setSelectedBills(currentBills.map((bill) => bill.ProposalID));
    //     } else {
    //         setSelectedBills([]);
    //     }
    // };


    // const approveorrejectSelected = async (condition) => {
    //     if (selectedBills.length === 0) {
    //         alert('No Proposal selected for approval!');
    //         return;
    //     }
    //     console.log(selectedBills);
    //     setLoading(true); // Start loader


    //     try {
    //         let response = await ProposalApprovalOperation(selectedBills, condition, remark); // Call backend function
    //         if (response.message) {
    //             alert(response.message);
    //             setRemark("");
    //             setRejectpanelhide(false)
    //             getTechnicalInwardsList(); // Refresh the list after approval
    //         }
    //         if (response.error) {
    //             alert(response.error)
    //             getTechnicalInwardsList(); // Refresh the list after approval
    //         }
    //     } catch (error) {
    //         console.error('Error approving Proposal:', error);
    //         alert('An error occurred while approving bills.');
    //     }
    //     setLoading(false); // Stop loader
    // };


    return (

        <>
            <div style={{ overflowX: "hidden", display: 'grid', justifyContent: 'center', padding: "20px 0px" }}>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "80vw", maxWidth: "1200px", marginBottom: "15px" }}>
                    <h4 style={{ margin: "10px" }}>Edit Work Order List</h4>
                    <input type="text" placeholder="Search" onChange={(e) => setSearchTerm(e.target.value)} value={searchTerm} style={{ width: "250px", padding: "8px 12px", border: "1px solid #ccc", borderRadius: "5px", backgroundColor: 'aliceblue', fontSize: "14px", marginRight: "10px" }} />
                </div>


                <div style={{ display: "grid", justifyContent: "center", boxShadow: "0px 0px 3px", borderRadius: "20px", width: "78vw", }}>
                    <div style={{ overflowX: "auto", width: "78vw", borderRadius: "20px", }}>
                        <table style={{ backgroundColor: "white", width: "100%", borderRadius: "20px", overflow: "hidden", borderCollapse: "collapse", }}>
                            <thead style={{ borderTop: "none" }}>
                                <tr style={{ background: 'linear-gradient(to bottom, #CCEAF7, #CFE4F1, #CCE1EE, #D8D9EC)', color: "black", border: "none", borderRadius: "10px", overflow: "hidden", height: "3rem", fontSize: "12px", textAlign: "center", }}>
                                    {/* <th style={{ width: "3%" }}><input
                                        type="checkbox"
                                        onChange={handleSelectAll}
                                        checked={selectedBills.length === currentBills.length}
                                        style={{ marginRight: '5px', height: '1.5rem', width: '1.5rem' }}
                                    />
                                    </th> */}
                                    {/* <th style={{ width: "3%" }}>View</th> */}
                                    <th style={{ width: "10%" }}>WorkOrder UID </th>
                                    <th style={{ width: "6%" }}>HeadCode</th>
                                    <th style={{ width: "10%" }}>GR UID</th>
                                    <th style={{ width: "10%" }}>Financial Year</th>
                                    <th style={{ width: "10%" }}>PAN No</th>
                                    <th style={{ width: "10%" }}>Contractor Name</th>
                                    <th style={{ width: "10%" }}>Work Name</th>
                                    <th style={{ width: "10%" }}>Work Order No.</th>
                                    <th style={{ width: "14%" }}>Remark</th>
                                    <th style={{ width: "10%" }}>Action</th>

                                </tr>
                            </thead>
                            <tbody>
                                {
                                    currentBills?.map((technicalInwards, index) => {
                                        const bgColor = index % 2 === 0 ? "#E5F4FB" : "#CFE4F1";
                                        return (
                                            <tr className='px-3' key={index} style={{ borderBottom: '1px solid #3b409e', backgroundColor: bgColor, }}>

                                                <td className='py-2'>{technicalInwards.WorkOrderID}</td>
                                                <td className='py-2'>{technicalInwards.HeadCode}</td>
                                                <td className='py-2'>{technicalInwards.GrID}</td>
                                                <td className='py-2'>{technicalInwards.ProposalYear}</td>
                                                <td className='py-2'>{technicalInwards.PanNo}</td>
                                                <td className='py-2'>{technicalInwards.ContractorName}</td>
                                                <td className='py-2'>{technicalInwards.WorkName}</td>
                                                <td className='py-2'>{technicalInwards.WorkOrderNo}</td>
                                                <td style={{ padding: '8px' }}>{technicalInwards.Remark}</td>
                                                <td style={{ padding: '8px' }}>
                                                    <button className='btn btn-success py-1 px-4' onClick={() => nav(`/AdminDashboard/EditWorkOrder/${technicalInwards.WorkOrderID}`)}>Edit</button>
                                                </td>


                                            </tr>
                                        )
                                    })
                                }
                            </tbody>
                        </table>
                    </div>
                </div>
                {/* <div style={{ display: 'flex', justifyContent: 'space-between', padding: ' 0px 10px 0px 10px', height: '3rem', alignItems: 'center' }}>
                    <div>
                        <p style={{ margin: '0px', color: 'black' }}>Showing {currentBills?.length} of {technicalInwards?.length} entries</p>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center' }}>

                        <button onClick={() => setCurrentPage(1)} disabled={currentPage === 1}
                            style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '24px', margin: 0, borderRadius: 0 }}>
                            &laquo;
                        </button>

                        <button
                            onClick={() => setCurrentPage(currentPage - 1)}
                            disabled={currentPage === 1}
                            style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '24px', margin: 0, borderRadius: 0, borderLeft: "none" }}>
                            &lt;
                        </button>

                        <button
                            style={{ background: 'linear-gradient(to Right, #3b409e , #0067ab , #0f79ba , #0098d5 )', color: 'white', cursor: 'pointer', fontSize: '24px', width: '3rem', margin: 0, borderRadius: 0, border: '1px solid lightgrey', borderLeft: "none" }}>{currentPage}
                        </button>

                        <button
                            onClick={() => setCurrentPage(currentPage + 1)}
                            disabled={currentPage === totalPages}
                            style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '24px', margin: 0, borderRadius: 0, borderLeft: "none" }}>
                            &gt;
                        </button>

                        <button
                            onClick={() => setCurrentPage(totalPages)}
                            disabled={currentPage === totalPages}
                            style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '24px', margin: 0, borderRadius: 0, borderLeft: "none" }}>
                            &raquo;
                        </button>
                    </div>

                </div> */}

                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-evenly', margin: '10px 0' }}>
                        {/* <button
                            onClick={() => approveorrejectSelected("Approved")} disabled={loading}
                            style={{ display: 'flex', alignItems: 'center', gap: '8px', margin: '12px', padding: '8px 15px', background: 'linear-gradient(to Right, #3b409e , #0067ab , #0f79ba , #0098d5 )', color: 'white', borderRadius: '5px', cursor: loading ? 'not-allowed' : 'pointer' }}
                        ><img style={{ width: '14px', filter: 'brightness(0) invert(1)' }} /> {loading ? 'Processing...' : 'Approve Selected'}
                        </button>

                        <button
                            onClick={() => setRejectpanelhide(2)} disabled={loading}
                            style={{ display: 'flex', alignItems: 'center', gap: '8px', margin: '12px', padding: '8px 15px', background: 'linear-gradient(to Right,rgb(158, 59, 59) ,rgb(171, 0, 0) ,rgb(186, 15, 15) ,rgb(213, 0, 0) )', color: 'white', borderRadius: '5px', cursor: loading ? 'not-allowed' : 'pointer' }}
                        ><img style={{ width: '14px', filter: 'brightness(0) invert(1)' }} /> {loading ? 'Processing...' : 'Reject Selected'}
                        </button>

                        <button
                            onClick={() => setRejectpanelhide(3)} disabled={loading}
                            style={{ display: 'flex', alignItems: 'center', gap: '8px', margin: '12px', padding: '8px 15px', background: 'linear-gradient(to Right,rgb(158, 127, 59) ,rgb(171, 140, 0) ,rgb(186, 140, 15) ,rgb(213, 156, 0) )', color: 'white', borderRadius: '5px', cursor: loading ? 'not-allowed' : 'pointer' }}
                        ><img style={{ width: '14px', filter: 'brightness(0) invert(1)' }} /> {loading ? 'Processing...' : 'Send Back Selected'}
                        </button> */}
                    </div>



                    <div style={{ display: 'flex', justifyContent: 'space-evenly', margin: '10px 0' }}>
                        <button
                            onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
                            disabled={currentPage === 1}
                            style={{ padding: '8px 15px', borderRadius: '5px', cursor: 'pointer', backgroundColor: currentPage === 1 ? '#ccc' : 'blue', color: 'white' }}
                        >
                            Previous
                        </button>
                        <span style={{ fontSize: '18px', fontWeight: 'bold' }}>
                            Page {currentPage} of {totalPages}
                        </span>
                        <button
                            onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}
                            disabled={currentPage === totalPages}
                            style={{ padding: '6px 15px', borderRadius: '5px', cursor: 'pointer', backgroundColor: currentPage === totalPages ? '#ccc' : 'blue', color: 'white' }}
                        >
                            Next
                        </button>
                    </div>


                </div>
            </div>

        </>

    )
}

export default EditWorkOrderList;